import { render } from "./ResetSidePaddings.vue?vue&type=template&id=45366882"
import script from "./ResetSidePaddings.vue?vue&type=script&lang=ts"
export * from "./ResetSidePaddings.vue?vue&type=script&lang=ts"
script.render = render

export default script